module.exports = __webpack_public_path__ + "static/media/fig.b25ccf1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fig.svg
// module id = 929
// module chunks = 0